module.exports = (app) => app.directive('ociCatalog', /* @ngInject */ function() {
    return {
        restrict: 'E',
        scope: {
            /**
             * @type {OciBackgroundSearchCatalog}
             */
            catalog: '='
        },
        templateUrl: `./${BUILD_PATH}/oci-background-search-catalog.directive.html`,
        controller: /* @ngInject */ function ($scope) {}
    };
});